import html2canvas from "html2canvas";

// Alternative export function that replaces inputs with divs for better rendering
const exportDivAsPngWithInputFix = async (
  containerRef: React.RefObject<HTMLDivElement>,
  filename?: string,
  exportType: "download" | "base64" = "download",
): Promise<string | void> => {
  try {
    if (!containerRef.current) {
      console.error("Container ref is not available");
      return;
    }

    // Store original inputs and their values
    const inputs = containerRef.current.querySelectorAll(
      'input[type="text"], input[type="color"]',
    );
    const inputData: Array<{
      element: HTMLInputElement;
      value: string;
      parent: HTMLElement;
      placeholder: HTMLDivElement;
    }> = [];

    // Replace inputs with divs temporarily
    inputs.forEach((input) => {
      const htmlInput = input as HTMLInputElement;
      const computedStyle = window.getComputedStyle(htmlInput);

      // create span to hold input value
      const span_content = document.createElement("span");
      span_content.textContent = htmlInput.value;
      span_content.style.transform = "translateY(-7px)";

      // Create a div that looks like the input
      const placeholder = document.createElement("div");
      placeholder.appendChild(span_content);
      placeholder.style.cssText = computedStyle.cssText;
      placeholder.style.border = computedStyle.border;
      placeholder.style.padding = computedStyle.padding;
      placeholder.style.lineHeight = computedStyle.lineHeight;
      placeholder.style.margin = computedStyle.margin;
      placeholder.style.fontSize = computedStyle.fontSize;
      placeholder.style.fontFamily = computedStyle.fontFamily;
      placeholder.style.color = computedStyle.color;
      placeholder.style.backgroundColor = computedStyle.backgroundColor;
      placeholder.style.width = computedStyle.width;
      placeholder.style.minHeight = computedStyle.minHeight;
      placeholder.style.height = "auto";
      placeholder.style.display = "flex";
      placeholder.style.alignItems = "center";
      placeholder.style.alignContent = "center";

      const parent = htmlInput.parentElement!;
      inputData.push({
        element: htmlInput,
        value: htmlInput.value,
        parent,
        placeholder,
      });

      // Replace input with div
      parent.replaceChild(placeholder, htmlInput);
    });

    try {
      // Configure html2canvas options for better quality
      const canvas = await html2canvas(containerRef.current, {
        backgroundColor: "#ffffff",
        scale: 2, // Higher resolution
        useCORS: true,
        allowTaint: true,
        logging: false,
        width: containerRef.current.offsetWidth,
        height: containerRef.current.offsetHeight,
      });

      const dataURL = canvas.toDataURL("image/png");

      if (exportType === "download") {
        // Create download link
        const link = document.createElement("a");
        link.download = `${filename || "component"}.png`;
        link.href = dataURL;

        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log("Component exported as PNG successfully");
      } else {
        // Return base64 data
        return dataURL;
      }
    } finally {
      // Restore original inputs
      inputData.forEach(({ element, parent, placeholder }) => {
        parent.replaceChild(element, placeholder);
      });
    }
  } catch (error) {
    console.error("Failed to export component as PNG:", error);
    throw error;
  }
};

export { exportDivAsPngWithInputFix };
